import { render } from "./BurnAlertModal.vue?vue&type=template&id=6f2c28f8"
import script from "./BurnAlertModal.vue?vue&type=script&lang=ts"
export * from "./BurnAlertModal.vue?vue&type=script&lang=ts"
script.render = render

export default script